import { FormInstanceRatingApiModel } from '../program/shared/form-instances/FormInstanceRatingApiModel';
import { FormInstancePerformanceCategoryBaseApiModel } from '../program/shared/form-instances/FormInstancePerformanceCategoryBaseApiModel';

export class PpBoundFormInstanceApiModel {
  public Id: number;
  public Name: string;
  public WorkDate: Date;
  public CurrentStepName: string;
  public CurrentStepId: number;
  public Location: string;
  public LocationId: number;
  public Shift: string;
  public ShiftId: number;
  public Trainer: string;
  public TrainerId: string;
  public InstanceNumber: string;
  public IsNotObserved: boolean;
  public PerformanceCategories: FormInstancePerformanceCategoryBaseApiModel[];
  public Ratings: FormInstanceRatingApiModel[];

  public deserialize(data: Object): PpBoundFormInstanceApiModel {
    Object.assign(this, data);

    this.WorkDate = new Date(this.WorkDate);

    return this;
  }
}
